import script from "./users-table.vue?vue&type=script&setup=true&lang=ts"
export * from "./users-table.vue?vue&type=script&setup=true&lang=ts"

import "./users-table.vue?vue&type=style&index=0&id=d13f0d95&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d13f0d95"]])

export default __exports__